import { Button} from '@chakra-ui/react';
import { handleBack } from '../utils';
import { InterviewUtils } from '../../../formSections/Interview/utils';

const BackButton = (props, groupedQuestions, step, buttonStyles) => {
  const sectionName = props.stateProps.sectionData.sectionName;
  if (step <= 0 || (sectionName === 'career-profile' && step===4)) {
    return null;
  } else {

    if (sectionName === 'interview-sparl' || sectionName === 'interview-you' || sectionName === 'interview-questions' || sectionName === 'grow-goals') {
      const iu = new InterviewUtils(props);
      return (
        <Button
          sx={{ ...buttonStyles.tertiary, ...buttonStyles.backButton }}
          onClick={() =>
            iu.handleInterviewBack(groupedQuestions, step)
          }
        >
          Back
        </Button>
      );
    } else {
      return (
        <Button
          sx={{ ...buttonStyles.tertiary, ...buttonStyles.backButton }}
          onClick={() => handleBack(props, groupedQuestions, step)}
        >
          Back
        </Button>
      );
    }
  }
};

export default BackButton;
